export default {
  UPDATE_VEHICLE_LIST: 'UPDATE_VEHICLE_LIST',
  ADD_VEHICLE: 'ADD_VEHICLE',
  DELETE_VEHICLE: 'DELETE_VEHICLE',
  EDIT_VEHICLE: 'EDIT_VEHICLE',
};
